export const maxDimensionsRule = {
    getMessage(field, [width, height], data) {
        return (data && data.message) || `The ${field}'s max size ${width} x ${height} (width x height).`;
    },
    validate(file, [width, height]) {
        const validateImage = (file, width, height) => {
            const URL = window.URL || window.webkitURL;
            return new Promise(resolve => {
                const image = new Image();
                image.onerror = () => resolve({ valid: false });
                image.onload = () => resolve({
                    valid: image.width <= Number(width) && image.height <= Number(height)
                });

                image.src = URL.createObjectURL(file);
            });
        };

        if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name)) {
            return false;
        }

        return validateImage(file, width, height);
    }
};

export const maxWidthHeightRatioRule = {
    getMessage(field, ratio, data) {
        return (data && data.message) || `The ${field}'s min ratio ${ratio}:1 (width:height).`;
    },
    validate(file, [ratio]) {
        const validateImage = (file, ratio) => {
            const URL = window.URL || window.webkitURL;
            return new Promise(resolve => {
                const image = new Image();
                image.onerror = () => resolve({ valid: false });
                image.onload = () => resolve({
                    valid: (image.width / image.height) >= Number(ratio),
                });

                image.src = URL.createObjectURL(file);
            });
        };

        if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name)) {
            return false;
        }

        return validateImage(file, ratio);
    }
};

let rouletteGameTypes = [1, 2, 3, 5, 6];

export const mustSetIsLeftForGameTypesRule = {
    getMessage(field, data) {
        return (data && data.message) || `Please provide "isLeft" key with value true or false since Game type is one of [${rouletteGameTypes}]`;
    },
    validate(gameType, [options]) {
        if (!options || !gameType) {
            return true;
        }

        gameType = Number.parseInt(gameType);

        if (!rouletteGameTypes.includes(gameType)) {
            return true;
        }

        return [true,false].includes(options.isLeft);
    }
};

export const minTrimmedLengthRule = {
    getMessage(field, [length],data) {
        return (data && data.message) || `The ${field} field must be at least ${length} characters`
    },
    validate(value, [length]) {
        if (typeof value !== 'string') {
            return true
        }

        return value.trim().length >= length
    }
};

